import React, {Component} from "react";

import ReportsRead from "components/Reports/Reports.jsx";

class Reports extends Component {
    render() {
        return <ReportsRead id={this.props}/>
    }
}
export default(Reports);


// WEBPACK FOOTER //
// ./src/views/Reports/Reports.jsx